import { track } from "../track";

export const trackContentLike = (params: { content_id: string }) =>
  track({ event: "content_like", ...params });
